import Popup from "../helpers/Popup";

$(document).ready(function () {
    $(document).on('click', '.popup__close, .popup-close', function () {
        Popup.get('#' + $(this).parents('.popup').get(0).id).close();
    });

    $(document).on('click', '[popup], [js-popup]', function (e) {
        e.preventDefault();

        const popup = $(this).attr('popup') ? '#' + $(this).attr('popup') : '#popup';

        Popup.get(popup).show($(this));

    });

    $(document).on('click', '.popup', function (e) {

        const target = $(e.target);

        if (target.hasClass('popup_active'))
            Popup.get('#' + target.get(0).id).close();

    });
});